import { Outlet } from 'react-router';
import { useEvent } from '../lib/queries';
import { SiteFooter } from './SiteFooter';
import { TabBar } from './TabBar';
import { TopBar } from './TopBar';

/** Home: the client's lockup on top, the footer underneath, and no tab bar in between. */
export function HomeLayout() {
  const event = useEvent();

  return (
    <>
      <TopBar event={event.data} />
      <div className="flex-1">
        <Outlet />
      </div>
      <SiteFooter event={event.data} />
    </>
  );
}

/**
 * Every other screen: its own header, and the tab bar. The bar is fixed, so the column ends
 * with enough room to scroll the last card clear of it.
 */
export function ScreenLayout() {
  return (
    <>
      <div className="flex-1 pb-[calc(var(--spacing-tabbar)+env(safe-area-inset-bottom))]">
        <Outlet />
      </div>
      <TabBar />
    </>
  );
}
